import type { FunctionTestWidgetConfig } from '../function-test.model';

export const FUNCTION_TEST_CIRCLE_PRESET: FunctionTestWidgetConfig = {
  id: 'function-test-circle',
  type: 'function-test',
  params: {
    curve: {
      type: 'parametric',
      x: '3 * cos(t)',
      y: '3 * sin(t)',
      range: [0, 6.283185307179586],
    },
  },
  display: {},
};
